import { render, staticRenderFns } from "./GlobalParamForm.vue?vue&type=template&id=5e0a5823&scoped=true"
import script from "./GlobalParamForm.vue?vue&type=script&lang=ts"
export * from "./GlobalParamForm.vue?vue&type=script&lang=ts"
import style0 from "./GlobalParamForm.vue?vue&type=style&index=0&id=5e0a5823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0a5823",
  null
  
)

export default component.exports